import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {fetchPresets, onDeletePreset, onSavePreset} from '../actions/PresetActions';
import isEmpty from 'lodash/isEmpty';
import Error from '../components/Error';
import Loading from '../components/Loading';
import EditPreset from '../components/PresetEdit';
import {Defaults} from '../Constants';

@connect(state => ({presets: state.presets}), {fetchPresets, onSavePreset, onDeletePreset})
export default class PresetEditContainer extends Component {
    static propTypes = {
        match: PropTypes.shape({
            params: PropTypes.shape({
                id: PropTypes.string
            })
        }),
        presets: PropTypes.object,
        fetchPresets: PropTypes.func,
        onSavePreset: PropTypes.func,
        onDeletePreset: PropTypes.func,
        history: PropTypes.object,
    };

    componentDidMount() {
        this.props.fetchPresets();
    }

    render() {
        const {presets} = this.props;
        if (isEmpty(presets)) {
            return false;
        }
        const {loading, error, items} = presets;
        if (!isEmpty(error)) {
            return <Error error={error}/>;
        }
        if (loading) {
            return <Loading/>;
        }
        const {match: {params}, history} = this.props;
        const id = parseInt(params.id, 10);
        const preset = items[id] || {};
        const defaultPreset = {
            amplitude: Defaults.AMPLITUDE,
            spread: Defaults.SPATIAL_SCALE,
        };
        const data = !id ? defaultPreset : preset;
        return (
            <div className="page">
                <div className="page_contents">
                    <h1>{'Preset'}</h1>
                    <div className="card" style={{minHeight: 600}}>
                        <EditPreset
                            initialValues={data}
                            history={history}
                            presetId={id}
                            onSubmit={this.props.onSavePreset}
                            onDeletePreset={this.props.onDeletePreset}
                            presets={items}
                        />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/PresetEditContainer.js